import { ModalController, Platform } from '@ionic/angular';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Image } from 'src/app/stores/product.store';
import { imageUrl } from 'src/environments/environment';
import Swiper from 'swiper';

@Component({
  selector: 'app-product-image-modal',
  templateUrl: './product-image-modal.component.html',
  styleUrls: ['./product-image-modal.component.scss'],
})
export class ProductImageModalComponent implements OnInit {
  @Input() image: Array<Image>;
  imageUrl = imageUrl;
  index: number = 0;
  @ViewChild('swiper')
  swiperRef: ElementRef | undefined;
  constructor(
    private modalCtrl: ModalController,
    private cdr: ChangeDetectorRef,
    public platform: Platform
  ) {}

  ngOnInit() {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  onSlideChange() {
    this.index = this.swiperRef?.nativeElement.swiper.activeIndex;
  }
}
